import { render, staticRenderFns } from "./MyBarChart.vue?vue&type=template&id=36e1722a"
import script from "./MyBarChart.vue?vue&type=script&lang=js"
export * from "./MyBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports